import * as types from "../actions/actionTypes";
const initialState = {
    is_fetched:false,
    loading: true,
    data: [],
    tool: {},
    last_item: "",
    last_child:"",
    storeStatus: null,
    error: false
};

const ConstructionPhase = (state = initialState, action) => {
    let data;
    switch (action.type) {
        case types.TOOLS_LIST_REQUEST:
            return {...state,loading: true};
        case types.TOOLS_LIST_SUCCESS:
            return {...state,data:action.payLoad,loading: false,is_fetched:true};
        case types.TOOLS_LIST_FAILURE:
            return {...state,loading: false};

        case types.TOOLS_ALL_REQUEST:
            return {...state,loading: true};
        case types.TOOLS_ALL_SUCCESS:            
            return {...state, data: action.payLoad, loading: false, is_fetched: true};
        case types.TOOLS_ALL_FAILURE:
            return {...state,loading: false};

        case types.TOOLS_SHOW_REQUEST:
            return {...state, tool: {}, loading: true};
        case types.TOOLS_SHOW_SUCCESS:            
            return {...state, tool: action.payLoad, loading: false, is_fetched: true};
        case types.TOOLS_SHOW_FAILURE:
            return {...state,loading: false};

        case types.TOOLS_STORE_REQUEST:
            return {...state,loading: true};
        case types.TOOLS_STORE_SUCCESS:
            state.data.push(action.payLoad);
            return {...state,last_item:action.payLoad,loading: false, storeStatus: true};
        case types.TOOLS_STORE_FAILURE:
            return {...state,loading: false, storeStatus: false};
        
        case types.TOOLS_UPDATE_REQUEST:
            return {...state,loading: true, storeStatus: false};
        case types.TOOLS_UPDATE_SUCCESS: 
            data = [];
            if(state.data.length) {
                data = state.data.map(item => (item.id === Number(action.payLoad.id) ? action.payLoad : item));
            }
            return {...state, data: data, tool: action.payLoad, loading: false, is_fetched: true, storeStatus: true};
        case types.TOOLS_UPDATE_FAILURE:
            return {...state,loading: false, error: true, storeStatus: false};        

        case types.TOOLS_REMOVE_REQUEST:
            return {...state, loading: true};
        case types.TOOLS_REMOVE_SUCCESS:
            data = state.data.filter(item => item.id !== Number(action.payLoad.id));
            return {...state, data: data, loading: false};
        case types.TOOLS_REMOVE_FAILURE:
            return {...state, loading: false};

        default:
            return state;
    }
};

export default ConstructionPhase;
